// a single rule for the trigger of a zap (filters the inbound data more)
// exporting this for legacy use

export default {
  icontains: '(Text) Contains',
  'not-icontains': '(Text) Does not contain',
  iexact: '(Text) Exactly matches',
  'not-iexact': '(Text) Does not exactly match',
  ireversecontains: '(Text) Is in',
  'not-ireversecontains': '(Text) Is not in',
  istartswith: '(Text) Starts with',
  'not-istartswith': '(Text) Does not start with',
  iendswith: '(Text) Ends with',
  'not-iendswith': '(Text) Does not end with',
  igreater: '(Number) Greater than',
  iless: '(Number) Less than',
  idategreater: '(Date/time) After',
  idateless: '(Date/time) Before',
  idateequal: '(Date/time) Equals',
  boolean: '(Boolean) Is true',
  'not-boolean': '(Boolean) Is false',
  iexist: 'Exists',
  'not-iexist': 'Does not exist',
};
